import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class BackOfANapkinSlideoversCustomerValuesComponent extends Component {
  @service organisation;
}
